import Link from 'next/link';
import type { PreviewRestaurant } from '@/lib/restaurantPreview';

export default function RestaurantPreview({ restaurants }: { restaurants: PreviewRestaurant[] }) {
  return (
    <>
      {restaurants.map((restaurant) => (
        <li key={restaurant.id} className="border-b border-ds-gray-light-200 p-4 lg:pl-0">
          <h2 className="text-lg font-bold">
            <Link href={restaurant.slug} prefetch={false} className="hover:underline">
              {restaurant.menuTitle}
            </Link>
          </h2>
          {restaurant.suburb?.menuTitle && <p>{restaurant.suburb.menuTitle}</p>}
          {!!restaurant.rating && !!restaurant.reviewsCount && (
            <p className="text-sm">
              {Number(restaurant.rating.toFixed(1))} / 5 · {restaurant.reviewsCount} reviews
            </p>
          )}
          <p className="text-sm">View menus, reviews and booking options.</p>
        </li>
      ))}
    </>
  );
}
